export default __webpack_public_path__ + "static/media/arrowDown.0b8c8954.svg";